import React from 'react';
import styled from 'styled-components';
import PaymentButton from '../../components/PaymentButton';
import { Pages } from '../../App';

interface Props {
	setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const ProcessRefundContent = ({ setCurrentPage }: Props) => {
	const handleEWalletClick = () => {
		window._satellite.track('process-refund-ewallet-refund');
		setCurrentPage(Pages.eWalletRefund);
	};

	return (
		<>
			<PageWrapper>
				<PaymentButton onClick={handleEWalletClick}>
					<InnerText>eWallet Refund</InnerText>
				</PaymentButton>
				<PaymentButton disabled={true}>
					<CallDiv>
						<InnerText>Credit Card Refund</InnerText>
						<FineInnerText>Please call 1-877-245-0903</FineInnerText>
					</CallDiv>
				</PaymentButton>
			</PageWrapper>
		</>
	);
};

const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 37px;
	gap: 15px;
`;

const InnerText = styled.p`
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	color: #e81111;
	margin: 10px 0 10px 0;
	text-align: left;
`;

const FineInnerText = styled.p`
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 15px;
	color: #333333;
	margin: 0;
`;

const CallDiv = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 6px;
	flex: 1 0 0;
	${InnerText} {
		color: #333333;
		margin: 0px;
	}
`;

export default ProcessRefundContent;
